export const eventMiddleware = () => (next) => (action) => {
  if (action.type === 'GET_EVENT') {
    let type = ((action.payload || {}).event || {}).type;
    if (type === 'message') {
      try {
        action.payload.event.data = JSON.parse(action.payload.event.data);
      } catch (e) {}
    }
  }
  next(action);
};
